import { connect } from 'react-redux';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';
import IsSpecificSchoolView from './IsSpecificSchoolView';
import nextIteratorsSelector from './IsSpecificSchoolSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
  };

  return { clientId, educationGoal, nextIterators: nextIteratorsSelector(state, ownProps) };
};

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: (data, educationGoal) => ({ [BACKEND_EDUCATION_GOAL_API]: educationGoal }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IsSpecificSchoolView);
